import ComplaintFormPathsMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-paths-mixin'
import ComplaintFormErrorTranslationsMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-error-translations-mixin'
import ComplaintFormErrorMixin from '@/js/components/Forms/ComplaintForm/_mixins/complaint-form-error-mixin'

export default {
  mixins: [ComplaintFormPathsMixin, ComplaintFormErrorTranslationsMixin, ComplaintFormErrorMixin],
}
